import React, {useState, useEffect} from 'react';
import {CSSTransition} from "react-transition-group";
import Layout from "../app/components/ui/layout/Layout";
import YearsList from "../app/components/YearsList";

const HomeScreen = () => {

    return (
        <Layout>
            <YearsList/>
        </Layout>
    );
};

export default HomeScreen;
